import React from "react";

function FormInputField({
  label,
  name,
  placeholder,
  value,
  type = "text",
  errorText,
  validationText,
  helpText,
  onChange,
  maxWidth,
  disabled = false,
  className,
  readOnly,
  minLength,
  maxLength,
}) {
  let classNameText = "input";
  if (errorText) {
    classNameText = "input is-danger";
  }
  return (
    <div class={`field pb-4 ${className}`}>
      <label class="label">{label}</label>
      <div class="control">
        <input
          class={classNameText}
          name={name}
          type={type}
          readOnly={readOnly}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={{ maxWidth: maxWidth }}
          maxLength={maxLength}
          disabled={disabled}
          autoComplete="off"
          minLength={minLength}
        />
      </div>
      {errorText && <p class="help is-danger">{errorText}</p>}
      {minLength < 5 && <p class="help is-danger">{name + "name invalid"}</p>}
      {helpText && <p class="help">{helpText}</p>}
    </div>
  );
}

export default FormInputField;
